import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ products, onCustomize, onAddToCart, addingId, isMarketClosed = false }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2   bg-white mb-[-30px]">
      {products?.map((product, index) => (
        <ProductCard
          className={index === 0 ? "mt-[0px]" : ""}
          key={product?.id}
          product={product}
          onCustomize={onCustomize}
          onAddToCart={onAddToCart}
          addingId={addingId}
          isMarketClosed={isMarketClosed}
          isLast={index === products.length - 1}
        />
      ))}
    </div>
  );
};

export default ProductGrid;